export default __webpack_public_path__ + "static/media/demand.1c441824.svg";